module.exports = __webpack_public_path__ + "img/14.69188b96.jpg";